import React, { useMemo, useRef, useState } from 'react';
import { useGetAllCopyMeBasketsQuery } from '../../../store/services/api';
import BasketItem from '../BasketItem';
import DiscoverHeader from '../Header';
import { useSelector } from 'react-redux';
import { selectUserId } from '../../../store/slices/user';
import LoadingIcons from 'react-loading-icons';
import { colors } from '../../../colors';

interface Props {
  credits: number | undefined;
  refresh: () => void;
  balances: Record<string, Record<string, number>> | undefined;
}

const CopyMeBaskets = (props: Props) => {
  const { credits, refresh, balances } = props;

  // Fetch all baskets
  const userId = useSelector(selectUserId);
  const { data, isLoading } = useGetAllCopyMeBasketsQuery(userId);
  const [activeBasket, setActiveBasket] = useState<string | undefined>();
  const [query, setQuery] = useState<string | undefined>();
  const scrollviewRef = useRef<HTMLDivElement | null>(null);

  const sortedData = useMemo(() => {
    if (!data) {
      return [];
    }

    const baskets = [...data.copyMeBaskets].filter(
      (b) =>
        !query ||
        b.friendlyName.includes(query) ||
        b.baseAssets.includes(query),
    );

    return baskets;
  }, [data, query]);

  const assetInfo = useMemo(() => {
    if (!data) {
      return {};
    }

    return data.assetInfo;
  }, [data]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginTop: 5,
        paddingLeft: 30,
        paddingRight: 30,
        overflowY: activeBasket ? 'hidden' : 'auto',
        marginBottom: 16,
      }}
    >
      <DiscoverHeader
        title={'Copy Me Baskets'}
        query={query}
        setQuery={setQuery}
        isLoading={isLoading}
        credits={credits}
      />

      {isLoading && (
        <div
          style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <LoadingIcons.Grid width={60} height={60} />
          <p
            style={{
              color: colors.white,
              fontWeight: 'bold',
              margin: 0,
              marginTop: 16,
            }}
          >
            Fetching this data could take a minute...
          </p>
          <p style={{ color: colors.white, fontWeight: 'bold', margin: 0 }}>
            Please hold on.
          </p>
        </div>
      )}

      {!!data && (
        <div
          ref={scrollviewRef}
          style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(49%,1fr) minmax(49%,1fr)',
            gap: 16,
            position: 'relative',
          }}
        >
          {sortedData.map((item) => (
            <BasketItem
              key={item.id}
              item={item}
              parentRef={scrollviewRef}
              refresh={refresh}
              activeBasket={activeBasket}
              setActiveBasket={setActiveBasket}
              assetInfo={assetInfo}
              balances={balances}
              credits={credits}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CopyMeBaskets;
